//import React, { useState } from "react";

import React, { useState } from "react";
import Select from "react-select";

import {
  getCountries,
  getStates,
  getCities
} from "../../../../../../../constants/geographyMaster";

export default function AddressForm({
  initialData,
  onSave,
  onCancel,
}) {
  const [form, setForm] = useState(
    initialData || {
      // 🔧 FIXED 2026-01-31 10:15 IST
      // OFFICE is NOT valid backend enum
      // Must match BusinessPartnerAddressType
      address_type: "REGISTERED",

      line1: "",
      line2: "",
      city: "",
      state: "",
      country: "INDIA",
      pincode: "",
      is_default: false,
    }
  );

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: 16,
        marginBottom: 16,
        background: "#f9fafb",
      }}
    >
      <div className="erp-form-grid">
        <div className="erp-field">
          <label>Address Type</label>

          <select
            value={form.address_type}
            onChange={(e) =>
              setForm({
                ...form,
                address_type: e.target.value,
              })
            }
          >
            {/* ✅ MUST MATCH BACKEND ENUM EXACTLY */}

            {/* FIXED 2026-01-31 10:15 IST */}
            <option value="REGISTERED">Registered</option>
            <option value="BILLING">Billing</option>
            <option value="SHIPPING">Shipping</option>
            <option value="FACTORY">Factory</option>
            <option value="BRANCH">Branch</option>
          </select>
        </div>

        <div className="erp-field">
          <label>Country</label>

          <Select
              options={getCountries()}
              value={
                getCountries().find(
                  (c) => c.value === form.country
                ) || null
              }
              onChange={(selected) =>
                setForm({
                  ...form,
                  country: selected?.value || "",
                  state: "",
                  city: "",
                })
              }
              isSearchable
              placeholder="Select Country"
            />
        </div>

        <div className="erp-field">
          <label>Address Line 1</label>
          <input
            value={form.line1}
            onChange={(e) =>
              setForm({
                ...form,
                line1: e.target.value,
              })
            }
          />
        </div>

        <div className="erp-field">
          <label>Address Line 2</label>
          <input
            value={form.line2}
            onChange={(e) =>
              setForm({
                ...form,
                line2: e.target.value,
              })
            }
          />
        </div>

        

        <div className="erp-field">
            <label>State</label>

            <Select
              options={getStates(form.country)}
              value={
                getStates(form.country).find(
                  (s) => s.value === form.state
                ) || null
              }
              onChange={(selected) =>
                setForm({
                  ...form,
                  state: selected?.value || "",
                  city: "",
                })
              }
              isSearchable
              placeholder="Select State"
            />
          </div>

          <div className="erp-field">
            <label>City</label>

            <Select
              options={getCities(
                form.country,
                form.state
              )}
              value={
                getCities(
                  form.country,
                  form.state
                ).find(
                  (c) => c.value === form.city
                ) || null
              }
              onChange={(selected) =>
                setForm({
                  ...form,
                  city: selected?.value || "",
                })
              }
              isSearchable
              placeholder="Select City"
            />
          </div>

        <div className="erp-field">
          <label>Pincode</label>
          <input
            value={form.pincode}
            onChange={(e) =>
              setForm({
                ...form,
                pincode: e.target.value,
              })
            }
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 24,
          }}
        >
          <input
            type="checkbox"
            checked={form.is_default}
            onChange={(e) =>
              setForm({
                ...form,
                is_default: e.target.checked,
              })
            }
          />
          Default Address
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
          marginTop: 16,
        }}
      >
        <button
          className="btn btn-secondary"
          onClick={onCancel}
        >
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={() => onSave(form)}
        >
          Save Address
        </button>
      </div>
    </div>
  );
}
